export default function (app) {
  //组件自动加载
  const requireComponent = require.context('@/components/', true, /\w+\.(vue|js)$/);
  requireComponent.keys().forEach((fileName) => {
    const config = requireComponent(fileName);
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1').replace(/\//g, '-');
    app.component(componentName, config.default || config);
  });
}
